export default __webpack_public_path__ + "static/media/Animation.7f6fa8a4.webp";